import { render, staticRenderFns } from "./salaryStructure.vue?vue&type=template&id=611e79c8&scoped=true"
import script from "./salaryStructure.vue?vue&type=script&lang=js"
export * from "./salaryStructure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611e79c8",
  null
  
)

export default component.exports